import React, { ReactElement } from "react";

type IconProps = {
  width?: number;
  height?: number;
  className?: string;
};

export default function SendIcon(props: IconProps): ReactElement {
  const { width = 14, height = 16, className = "" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      className={className}
      height={height}
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        d="M13.5873 7.20457L1.31781 0.120734C0.614609 -0.285106 -0.215071 0.400094 0.0508492 1.16713L2.19861 7.36705C2.29797 7.65409 2.29797 7.96657 2.19861 8.25361L0.0508492 14.4535C-0.214831 15.2208 0.614849 15.906 1.31781 15.4999L13.5873 8.41609C14.0536 8.14681 14.0536 7.47361 13.5873 7.20457Z"
        fill="#F9EFFF"
      />
    </svg>
  );
}
